import styled from '@emotion/styled';

import {
  breakpoints,
  colors,
  fontSize,
  fontWeight,
} from '@datacamp/waffles-tokens';

export const Wrapper = styled.footer`
  background: #14243e;
  color: ${colors.white};
  padding: 64px 0 48px;
`;

export const Container = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;

  &:before {
    content: ' ';
    display: table;
  }

  &:after {
    content: ' ';
    display: table;
    clear: both;
  }

  @media screen and (min-width: ${breakpoints.sm}) {
    width: 750px;
  }

  @media screen and (min-width: ${breakpoints.md}) {
    width: 970px;
  }

  @media screen and (min-width: ${breakpoints.lg}) {
    width: 1170px;
  }
`;

export const Row = styled.div`
  margin-left: -16px;
  margin-right: -16px;

  &:before {
    content: ' ';
    display: table;
  }

  &:after {
    content: ' ';
    display: table;
    clear: both;
  }
`;

export const Title = styled.h3`
  font-size: ${fontSize.small};
  font-weight: ${fontWeight.bold};
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${colors.white};
  margin-bottom: 24px;
`;

export const List = styled.ul`
  list-style: none;
  margin-bottom: 0;
  margin-top: 0;
  padding-left: 0;
`;

export const ListItem = styled.li`
  margin-bottom: 12px;
`;

export const ListLink = styled.a`
  border-bottom: 0;
  font-weight: ${fontWeight.regular};
  color: ${colors.primaryLight};
`;

export const LogoBlock = styled.div`
  position: relative;
`;

export const Logo = styled.img`
  display: inline-block;
  vertical-align: top;
  height: 38px;
`;

export const SmallColumn = styled.div`
  min-height: 1px;
  padding-left: 16px;
  padding-right: 16px;
  position: relative;
  margin-bottom: 48px !important;

  @media screen and (min-width: ${breakpoints.sm}) {
    float: left;
    width: 50%;
  }

  @media screen and (min-width: ${breakpoints.md}) {
    width: 16.66666667%;
    float: left;
  }
`;

export const Column = styled.div`
  min-height: 1px;
  padding-left: 16px;
  padding-right: 16px;
  position: relative;

  @media screen and (min-width: ${breakpoints.sm}) {
    float: left;
    width: 100%;
  }

  @media screen and (min-width: ${breakpoints.md}) {
    width: 33.33333333%;
    float: left;
  }
`;

export const ClearFix = styled.div`
  display: none;
`;

export const LearnMore = styled.a`
  border-bottom: 0;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const MobileBadges = styled.div`
  margin-top: 32px;

  @media screen and (min-width: ${breakpoints.sm}) {
    bottom: 0;
    margin-top: 0;
    position: absolute;
    right: 0;
  }

  @media screen and (min-width: ${breakpoints.md}) {
    bottom: 24px;
    left: 16px;
    right: auto;
  }
`;

export const Badge = styled.a`
  border-bottom: 0;
  font-weight: ${fontWeight.normal};
  display: inline-block;

  &:last-of-type {
    margin-left: 12px;
  }
`;
